import { useState, useEffect, useRef, useCallback } from "react";
import { BigNumber, ethers } from "ethers";
import { GlobalContext } from "./useGlobal";
import Bignumber from "bignumber.js";
import http from "../utils/http";
import { ueContract } from "../contract/useContract";
import {
  RunbitAddress,
  RunbitAbi,
} from "../contract/address";

import { Modal, Toast, Mask } from "antd-mobile";
import { Dialog } from "react-vant";
import { useIntl } from "react-intl";
import { handlerWalletTxError } from "../utils/utils";

import useWallet from "./Wallet/useWallet";
import { calculateDiffTime } from "./../utils/utils";
import { getUserInfo } from "../contract/useRunbitProxy";
import { getMyEquips, getMyCards } from "../contract/useEquipCard";
import useInviterCodeModal from "../components/useInviterCodeModal";
import {
  getNameByTokenId,
  getGasoracle,
  getUserInfo as getUserInfoByApi,
  getUserShoesInfo
} from "../api";
import { IMAGE_PREFIX_URL } from "../utils/constants";
import useCommon from "./Common/useCommon";
import usePersonSign from "./usePersonSign";

export default function GlobalProvider({ children }) {
  const loading = useRef();
  const failRequestCount = useRef(0);
  const [rbPrice, setRbPrice] = useState(0);
  const [stepNum, setStepNum] = useState(0);
  const [stepStaus, setStepStaus] = useState(0);
  const [checkSum, setCheckSum] = useState(0);
  const [inviter, setInviter] = useState("");
  const [userInfo, setUserInfo] = useState();
  const [myEquips, setMyEquips] = useState();
  const [myCards, setMyCards] = useState();
  const [gasPrice, setGasPrice] = useState();
  const [homeTabactive, setHomeTabactive] = useState(0);
  const [txHashMap, setHashMap] = useState({});
  const [canPlay, setCanPlay] = useState(false);
  const [runContract, setRunContract] = useState();
  const {sendUserBind} = usePersonSign()
  const intl = useIntl();
  const initTimer = useRef();
  const { provider, myAccount, toLogin, chainId, getAccountBalance } =
    useWallet();
  const { lang } = useCommon();
  const inviterCodeModal = useInviterCodeModal();
  const txHashRef = useRef({});
  const [mountedEquip, setMountedEquip] = useState();

  useEffect(() => {
    getPrice();
    
  }, []);

  useEffect(() => {
    clearAllData();
    if (myAccount && myAccount.account) {
      ueContract(RunbitAddress, RunbitAbi).then((contract) => {
        setRunContract(contract);
      });
      getCanPlay();
    }
    return () => {
      Toast.clear();
      Modal.clear();
      initTimer.current && clearTimeout(initTimer.current);
    };
  }, [myAccount]);

  const addTxHashList = (type, tx, value, i18n = {}) => {
    txHashRef.current[tx.hash] = {
      type,
      tx: tx.hash,
      value,
      i18n,
    };
    if ("mount_equip" === type) {
      setMountedEquip(value);
    }
    setHashMap({ ...txHashRef.current });
    window.localStorage.setItem(
      "RUNBIT_PENGING_TXS_3_",
      JSON.stringify(txHashRef.current)
    );
    return getTxReceipt(tx);
  };
  const getTxReceipt = useCallback(
    async (tx) => {
      // const p = new ethers.providers.JsonRpcProvider(
      //   "https://nameless-serene-model.matic.quiknode.pro/1f1fb3c76ee84cdde7921f8ee612c87e92da9900/"
      // );
      const p = provider;
      if (!p) return;
      let receipt = {};
      if (tx.wait) {
        try {
          receipt = await tx.wait(3);
        } catch (e) {
          receipt = e.receipt;
        }
      } else {
        receipt = await p.waitForTransaction(tx.hash);
      }
      const txmap = txHashRef.current[tx.hash];
      delete txHashRef.current[tx.hash];
      console.log("waitForTransaction", receipt, txHashRef.current);
      setHashMap({ ...txHashRef.current });
      window.localStorage.setItem(
        "RUNBIT_PENGING_TXS_3_",
        JSON.stringify(txHashRef.current)
      );
      if (receipt.status > 0) {
        console.log("success");
        if (txmap.i18n.success) {
          Toast.show({
            content: intl.formatMessage({
              id: txmap.i18n.success,
            }),
            icon: "success",
          });
        }
        // 刷新
        loadUserInfo();
      } else {
        console.log("error");
        if (txmap.i18n.fail) {
          Toast.show({
            content: intl.formatMessage({
              id: txmap.i18n.fail,
            }),
            icon: "fail",
          });
        }
      }
    },
    [txHashMap, provider, myAccount]
  );
  const refreshDataByType = useCallback(
    (type) => {
      // mount_equip mount_card sync set_track
      // unmount_equip unmount_card compose tranfer_card  tranfer_equip
      // claim_lottery
      // claim_profit harvest_profit_by_day harvest_profit_by_date_range

      if (
        [
          "mount_equip",
          "unmount_equip",
          "sync",
          "set_track",
          "mount_card",
          "unmount_card",
        ].includes(type)
      ) {
        loadUserInfo();
      }
      if (
        [
          "mount_equip",
          "unmount_equip",
          "compose",
          "tranfer_equip",
          "mount_card",
          "unmount_card",
          "sync",
        ].includes(type)
      ) {
        loadMyEquips();
      }
      if (
        ["mount_card", "unmount_card", "tranfer_card", "sync"].includes(type)
      ) {
        loadMyCards();
      }
      if (["sync"].includes(type)) {
        syncStepNum();
      }
    },
    [myAccount]
  );
  const clearAllData = () => {
    setRbPrice(0);
    setStepNum(0);
    setStepStaus(0);
    setCheckSum(0);
    setInviter("");
    setUserInfo("");
    setMyEquips([]);
    setMyCards([]);
    setGasPrice(0);
    setCanPlay(false);
  };
  const initStorgeValue = () => {
    try {
      const userInfoStorge = window.localStorage.getItem(
        "RUNBIT_USERINFO_4_" + myAccount.uiAccount
      );
      if (userInfoStorge) {
        const info = JSON.parse(userInfoStorge);
        info.reward = undefined;
        info.steps = undefined;
        setUserInfo(info);
      }
      let txs = window.localStorage.getItem("RUNBIT_PENGING_TXS_3_");
      if (txs) {
        txs = JSON.parse(txs);
        Object.entries(txs).forEach(([key, e]) => {
          addTxHashList(e.type, { hash: key }, e.value, e.i18n);
        });
      }
    } catch (e) {
      console.log(e);
    }
  };


  const loadUserShoesInfo = async(info) => {
    const shoesInfo = await getUserShoesInfo({ addr:myAccount.account });
    const u = {
      ...info,
      ...shoesInfo.data,
    }
    console.log('u',u)
    setUserInfo(u)
  }
  const getCanPlay = async () => {
    // 判断是否有激活码
    console.log("判断是否有激活码");
    const hasInviterCode = await getInviter();
    if (hasInviterCode) {
      setCanPlay(true);
      initStorgeValue();
    } else {
      clearAllData()
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
  };
  const init = async () => {
    if (canPlay) {
      if (!userInfo) {
        showLoading(
          intl.formatMessage({
            id: "common.syncing_from_chain",
            defaultMessage: "正在同步链上数据...",
          }),
          loading
        );
      }
      Promise.all([syncStepNum(), loadUserInfo(), getAccountBalance()])
        .then(async () => {
          closeLoading(loading);
          failRequestCount.current = 0;
        })
        .catch((e) => {
          console.error(e);
          closeLoading(loading);
          const text = intl.formatMessage({
            id: "common.load_error",
            defaultMessage: "数据请求失败，请检查网络是否稳定",
          });
          const okText = intl.formatMessage({
            id: "common.ok",
            defaultMessage: "好的",
          });

          initTimer.current && clearTimeout(initTimer.current);
          initTimer.current = setTimeout(() => {
            if (failRequestCount.current >= 5) {
              Dialog.alert({
                message: text,
                confirmButtonText: okText,
                onClosed: () => {
                  failRequestCount.current = 0;
                  init();
                },
              });
            } else {
              init();
              failRequestCount.current += 1;
            }
          }, 3000);
        });
    }
  };

  const getPrice = () => {
    console.log("get rbprice start");
    http({
      url: "game/getPrice",
      method: "GET",
    }).then((res) => {
      const rbPrice = res.data;
      setRbPrice(rbPrice);
      console.log("get rbprice end", rbPrice);
    });
  };

  const syncStepNum = () => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: "game/getUserLastSteps",
        params: {
          addr: myAccount.account,
        },
      }).then((res) => {
        const { steps, timestamp, check_sum } = res.data;
        setStepNum(steps);
        const min = calculateDiffTime(timestamp);
        if (steps == 0 || parseInt(min) > 1) {
          console.log("离线-" + min);
          setStepStaus(0);
        } else {
          console.log("在线-" + min);
          setStepStaus(1);
        }
        setCheckSum(check_sum);
        resolve();
      });
    });
  };

  const loadUserInfo = useCallback(() => {
    return getUserInfo(myAccount.account).then((userInfo) => {
      console.log("userInfo", userInfo);
      setUserInfo(userInfo);
      return userInfo;
    });
  }, [myAccount]);
  const getInviter = async () => {
    try {
      // 是否是有邀请码
      const {
        data: { master_address },
      } = await getUserInfoByApi({ addr: myAccount.account });
      setInviter(master_address);
      return master_address;
    }catch(e) {
      
        inviterCodeModal.show({
          onConfrim: (code) => {
            sendInvterCode(code);
          },
        });
     
      

    }
   return ''
    
   
  };
  const getGasPrice = async (limit = 0, times = 1.3) => {
    console.log("times", times);
    getTxOptions(); 
    const price = await provider.getGasPrice();
    console.log("price", parseInt(price * times));
    const pricetime = times;
    const limittime = 1.2;
    let gasLimit = limit;
    if (!gasLimit) {
      gasLimit = await provider.estimateGas({ from: myAccount.account });
    }
    gasLimit = Math.ceil(gasLimit.toNumber() * limittime);
    let balance = await provider.getBalance(myAccount.account);
    balance = ethers.utils.formatEther(balance);
    const unitPrice = ethers.utils.formatEther(price);
    console.log("unitPrice", unitPrice);
    const gesfee = new Bignumber(unitPrice)
      .multipliedBy(pricetime)
      .multipliedBy(gasLimit)
      .toString();
    console.log("gas fee", gesfee);
    console.log("account balance", balance);
    if (new Bignumber(balance).lt(new Bignumber(gesfee))) {
      throw { code: "c_1001", message: "fee not engouh" };
      return;
    }
    const gasPrice = parseInt(price * pricetime);
    setGasPrice({
      price: gasPrice,
      unitPrice: price,
      uiPrice: gasPrice.toString(),
      gasLimit,
    });

    return {
      price: gasPrice,
      unitPrice: price,
      uiPrice: gasPrice.toString(),
      gasLimit,
    };
  };
  const getTxOptions = async (gasLimit) => {
    try{
    // console.log('getTxOptions ---> start ')
    const limittime = 1.2;
    const res = await getGasoracle();
    let { suggestBaseFee, FastGasPrice, gasUsedRatio } = res.data.result;
    suggestBaseFee = new Bignumber(suggestBaseFee);
    const fastGasPrice = new Bignumber(FastGasPrice);
    const gasUsedRatios = gasUsedRatio.split(",") || [];
    const totalGasUsedRatio = gasUsedRatios.reduce((t, c, i, a) => {
      return t.plus(Bignumber(c));
    }, Bignumber(0));

    const gasUsed = totalGasUsedRatio.dividedBy(gasUsedRatios.length).dividedBy(4).plus(1)

    // 公式： Max Priority Fee = FastGasPrice  +（suggestBaseFee） * ( gasUsedRatio的平均值/4)
    let maxPriorityFeePerGas = fastGasPrice.plus(suggestBaseFee.multipliedBy(gasUsed))
    // 公式： maxFeePerGas  = maxPriorityFeePerGas + suggestBaseFee
    let maxFeePerGas = maxPriorityFeePerGas.plus(suggestBaseFee)


    maxFeePerGas = ethers.utils.parseUnits(maxFeePerGas.toFixed(9), "gwei").toHexString();

    maxPriorityFeePerGas = ethers.utils
      .parseUnits(maxPriorityFeePerGas.toFixed(9), "gwei")
      .toHexString();

    console.log({ maxPriorityFeePerGas, maxFeePerGas });

    if (!gasLimit) {
      gasLimit = await provider.estimateGas({ from: myAccount.account });
    }
    gasLimit = Math.ceil(gasLimit.toNumber() * limittime);
    return {
      gasLimit,
      maxPriorityFeePerGas,
      maxFeePerGas,
      type: 2,
    };
  }catch(e) {
    console.log("get getTxOptions error", e)
  }
  };

  const getRealTimeGasWei = async () => {
    const price = await provider.getGasPrice();
    const pricetime = 1.2;
    const gasWei = ethers.utils.formatEther(price);
    const pow = Bignumber(10).pow(9);
    const gasWeiPrice = new Bignumber(gasWei)
      .multipliedBy(pricetime)
      .multipliedBy(pow)
      .toFixed(1);
    return gasWeiPrice.toString();
  };

  const sendInvterCode = async (invterCode) => {
    const isAddress = ethers.utils.isAddress(invterCode);

    if (!isAddress) {
      Toast.show({
        icon: "fail",
        content: intl.formatMessage({
          id: "common.invite_code_error",
          defaultMessage: "激活碼錯誤",
        }),
      });
      return;
    }
    try {
      showLoading(
        intl.formatMessage({
          id: "common.processing",
          defaultMessage: "交易中...",
        }),
        loading
      );
      await sendUserBind(invterCode);
      setInviter(invterCode);
      setCanPlay(true)
      Toast.show({
        content: intl.formatMessage({
          id: "common.invite_code_success",
          defaultMessage: "激活成功",
        }),
        icon: "success",
      });
      Modal.clear();
      loadUserInfo()
    } catch (e) {
      const reason = handlerWalletTxError(e, intl);
      Toast.show({
        icon: "fail",
        content: (
          <div className="text-center">
            <div>
              {intl.formatMessage({
                id: "common.invite_code_fail",
                defaultMessage: "激活失敗",
              })}
            </div>
            <div>{reason}</div>
          </div>
        ),
      });
    }
  };

  const loadMyEquips = async () => {
    const res = await getMyEquips(myAccount.account);
    if (res && res.length) {
      const names = await getNameByTokenId({
        token_id: res.map((e) => e.id).join(","),
        collection_type: 1,
        lang: lang === "en" ? "en" : "cn",
      });

      res.forEach((e, i) => {
        e.name = names.data[i].name;
        // e.img = e.img.replace(urlReg, CHAIN_IMAGE_PREFIX_URL);
        // e.img = CHAIN_IMAGE_PREFIX_URL + '/eout/' +e.img
        e.goodImg = IMAGE_PREFIX_URL + "/images/" + names.data[i].img;
        e.equip.ori_level = e.equip.level;
        if (e.equip.level >= 3) {
          e.equip.level = e.equip.level - 2;
        }
        // e.cards.forEach((c) => {
        //   if (c.img) {
        //     // c.img = c.img.replace(urlReg, CHAIN_IMAGE_PREFIX_URL);
        //     // c.img = CHAIN_IMAGE_PREFIX_URL + '/cout/'  + c.img
        //   }
        // });
      });
    }
    console.log("my equips", res);

    setMyEquips(res);
    return res;
  };
  const loadMyCards = async () => {
    const res = await getMyCards(myAccount.account);
    if (res && res.length) {
      // const names = await getNameByTokenId({
      //   token_id: res.map((e) => e.id).join(","),
      //   collection_type: 2,
      //   lang: lang === "en" ? "en" : "cn",
      // });
      res.forEach((e, i) => {
        // e.name = names.data[i].name;
        // e.img = e.img.replace(urlReg, CHAIN_IMAGE_PREFIX_URL);
        // e.img = CHAIN_IMAGE_PREFIX_URL + '/cout/'  + e.img
        e.card.ori_level = e.card.level;
        if (e.card.level >= 3) {
          e.card.level = e.card.level - 2;
        }
      });
    }
    console.log("my cards", res);

    setMyCards(res);
    return res;
  };
  const showLoading = (text, instance) => {
    console.log(text);
    const m = Toast.show({
      icon: "loading",
      duration: 0,
      content: text,
      maskClickable: false,
    });
    if (instance) {
      instance.current = m;
    }
    return m;
  };
  const closeLoading = (instance) => {
    if (instance && instance.current) {
      instance.current.close();
    }
  };
  const updateUserInfo = (prop, value) => {
    if (userInfo) {
      userInfo[prop] = value;
    }
    console.log("updateUserInfo", userInfo);
    setUserInfo({ ...userInfo });
  };
  useEffect(() => {
    if (userInfo) {
      window.localStorage.setItem(
        "RUNBIT_USERINFO_4_" + myAccount.uiAccount,
        JSON.stringify(userInfo)
      );
    }
  }, [userInfo]);
  const updateMyEquipsOrMyCards = (options = [], type) => {
    const data = type === "equip" ? myEquips : myCards;
    if (data && data.length) {
      const newData = [...data];
      options.forEach(({ type, prop, id, value }) => {
        const index = newData.findIndex((e) => e.id === id);
        if (type === "delete") {
          newData.splice(index, 1);
        }
        if (type === "update") {
          newData[index][prop] = value;
        }
      });
      console.log("updateMyEquipsOrMyCards", type, newData);
      if (type === "equip") {
        setMyEquips(newData);
      } else {
        setMyCards(newData);
      }
    }
  };
  useEffect(() => {
    if (myEquips && myEquips.length) {
      window.localStorage.setItem(
        "RUNBIT_EQUIPS_" + myAccount.uiAccount,
        JSON.stringify(myEquips)
      );
    }
  }, [myEquips]);
  useEffect(() => {
    if (myCards && myCards.length) {
      window.localStorage.setItem(
        "RUNBIT_CARDS_" + myAccount.uiAccount,
        JSON.stringify(myCards)
      );
    }
  }, [myCards]);

  return (
    <GlobalContext.Provider
      value={{
        inviter,
        rbPrice,
        stepStaus,
        userInfo,
        setUserInfo,
        stepNum,
        myEquips,
        checkSum,
        setStepNum,
        runContract,
        loadUserInfo,
        loadMyEquips,
        loadMyCards,
        gasPrice,
        myCards,
        getGasPrice,
        showLoading,
        closeLoading,
        updateUserInfo,
        syncStepNum,
        canPlay,
        getAllInfo: init,
        loadUserShoesInfo,
        homeTabactive,
        setHomeTabactive,
        updateMyEquipsOrMyCards,
        txHashMap,
        addTxHashList,
        mountedEquip,
        getRealTimeGasWei,
        getTxOptions,
      }}
    >
      {children}
      <Mask
        visible={!canPlay}
        onMaskClick={() => {
          // console.log("mask click");
          toLogin();
        }}
        opacity={0}
      />
    </GlobalContext.Provider>
  );
}
